/**
 * Sync status management utilities
 */

// Update sync status with minimalistic indicator (safe version)
export function setSyncStatus(status, text) {
  // Only try to update if we're in the main app (not on auth page)
  if (document.getElementById('main-container') && !document.getElementById('main-container').classList.contains('hidden')) {
    const syncIndicator = document.getElementById('sync-indicator');
    
    if (syncIndicator) {
      syncIndicator.className = `sync-indicator ${status}`;
      syncIndicator.title = text; // Show text on hover
      console.log('Sync status updated:', status, '-', text);
      
      // Update sticky header indicator
      updateStickyIndicator();
    } else {
      console.log('Sync indicator element not found');
    }
  } else {
    console.log('Sync status called during auth phase:', status, '-', text);
  }
}

// Update sticky header indicator to match main indicator
function updateStickyIndicator() {
  const mainIndicator = document.getElementById('sync-indicator');
  const stickyIndicator = document.getElementById('sticky-sync-indicator');
  
  if (mainIndicator && stickyIndicator) {
    // Copy all classes from main to sticky
    stickyIndicator.className = mainIndicator.className.replace('sync-indicator', 'sticky-sync-indicator');
    stickyIndicator.title = mainIndicator.title;
  }
}

// Sync status constants
export const SYNC_STATUS = {
  SYNCED: 'synced',
  SYNCING: 'syncing',
  ERROR: 'error',
  OFFLINE: 'offline'
};

// Helper functions for common sync statuses
export function setSynced(text = 'Data synced') {
  setSyncStatus(SYNC_STATUS.SYNCED, text);
}

export function setSyncing(text = 'Syncing...') {
  setSyncStatus(SYNC_STATUS.SYNCING, text);
}

export function setSyncError(text = 'Sync error') {
  setSyncStatus(SYNC_STATUS.ERROR, text);
}

export function setOffline(text = 'Offline') {
  setSyncStatus(SYNC_STATUS.OFFLINE, text);
}